"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePreFilterConfig = void 0;
const common_1 = require("@finley-technologies/common");
const validatePreFilterConfig = (_transformation) => {
    // since this is pre-sanitize operation there
    // is not much to validate here.
    return null;
};
exports.validatePreFilterConfig = validatePreFilterConfig;
const convertErrorToString = (e) => {
    // if there was a message there return it, otherwise stringify.
    const message = 'message' in e ? e.message : JSON.stringify(e);
    return message;
};
const doTransform = (params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { srcDataTapeBuffer, transformation } = params;
        const { data } = common_1.csvConversion.csvBufferToJsonArray({
            csvBuffer: srcDataTapeBuffer,
        });
        // filter by exclude config
        const filteredData = data.filter((row) => {
            const filterOut = transformation.exclude.find((exclude) => {
                const { field, values } = exclude;
                if (field in row) {
                    return values.includes(row[field]);
                }
                throw new Error(`[field:${field}] does not exist in input tape`);
            });
            return !filterOut;
        });
        const outputBuffer = common_1.csvConversion.csvArrayToFinleyBuffer({
            csvArray: filteredData,
        });
        return { isValid: true, data: { outputBuffer }, supplementals: [] };
    }
    catch (error) {
        const errors = [
            {
                type: 'preFilterValidation',
                message: convertErrorToString(error),
            },
        ];
        return { isValid: false, errors };
    }
});
exports.default = {
    doTransform,
    validatePreFilterConfig: exports.validatePreFilterConfig,
};
//# sourceMappingURL=preFilter-transform.js.map